enum ConferenceStatusCode {
  succeeded = 20000,
  notAuthorized = 40200,
  permissionDenied = 40001,
}

export default ConferenceStatusCode;
